module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('columns', [_c('column', {
    attrs: {
      "size": "2"
    }
  }, [_c('logo'), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "note"
  }, [_vm._v("© 2006-2018, ООО «АРК-Эгергосбыт»."), _c('br'), _vm._v("Все права защищены")]), _vm._v(" "), _c('a', {
    staticClass: "note",
    attrs: {
      "href": "mailto:info@arkenergosbyt.ru"
    }
  }, [_vm._v("info@arkenergosbyt.ru")])], 1), _vm._v(" "), _c('column', {
    attrs: {
      "size": "2",
      "mobile": false
    }
  }, [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": "/about"
    }
  }, [_vm._v("О компании")]), _vm._v(" "), _c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": "/vacancies"
    }
  }, [_vm._v("Вакансии")]), _vm._v(" "), _c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": "/legal"
    }
  }, [_vm._v("Раскрытие информации")]), _vm._v(" "), _c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": "/contacts"
    }
  }, [_vm._v("Контакты")]), _vm._v(" "), _c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": "/profile"
    }
  }, [_vm._v("Личный кабинет")])], 1), _vm._v(" "), _c('column', {
    attrs: {
      "size": "2",
      "mobile": false
    }
  }, [_c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": "/power"
    }
  }, [_vm._v("Энергосбережение")]), _vm._v(" "), _c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": "/accounting"
    }
  }, [_vm._v("Системы учёта")]), _vm._v(" "), _c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": "/audit"
    }
  }, [_vm._v("Энергоаудит")]), _vm._v(" "), _c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": "/consulting"
    }
  }, [_vm._v("Консалтинг")]), _vm._v(" "), _c('router-link', {
    staticClass: "router-link",
    attrs: {
      "to": "/trading"
    }
  }, [_vm._v("Энерготрейдинг")])], 1), _vm._v(" "), _c('column', {
    attrs: {
      "size": "4"
    }
  }, [_c('p', [_vm._v("Адрес:")]), _vm._v(" "), _c('heading', {
    attrs: {
      "type": "h4",
      "size": "s"
    }
  }, [_vm._v("г. Москва, ул. Садовая-Кудринская д. 11, стр. 1")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "tel:84957739215"
    }
  }, [_vm._v("8 (495) 773-92-15")])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-620c9f61"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FooterBar.vue
// module id = 131
// module chunks = 0